export enum ContractStepperEnum {
  TokenStep = 'TokenStep',
  PreContract = 'PreContract',
  DeviceDetails = 'DeviceDetails',
  ContractSignature = 'ContractSignature',
}
